$( document ).ready(function() {
    $('.court-color-config-picker .inner-court li').click(function(event) {
        $('.court-color-config-picker .inner-court li').removeClass('active');
        var inner_color = $(this).data('color');
        $(this).addClass('active');
        $('.court-color-config .inner-court img').css('background', '#' + inner_color);
    });
    $('.court-color-config-picker .outer-court li').click(function(event) {
        $('.court-color-config-picker .outer-court li').removeClass('active');
        var outer_color = $(this).data('color');
        $(this).addClass('active');
        $('.court-color-config .outer-court img').css('background', '#' + outer_color);
    });
});
